export default "__VITE_ASSET__wisdAfra__"